import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { categoryType, currencyType, focusedDocumentType, paymentTypeType } from "custom-prop-types";
import styles from "components/upload-documents/processing-fields.scss";
import { Button } from "components/common/button";
import {
  FormButton,
  renderFormElement,
  renderFormNumberElement,
  renderFormCalculateTaxElement,
  renderPaymentTypeElement
} from "components/common/form-elements";
import { DocumentTypeSelector } from "components/upload-documents/processing-fields";

let PendingReceiptForm = ({
  accountId,
  categories,
  change,
  currencies,
  currency,
  documentType,
  focusedDocument,
  formPaymentType,
  onChangeDocumentType,
  onCreateCategory,
  onReprocessPendingDocument,
  onSavePendingDocument,
  onShowTrashDocument,
  preferredCurrency,
  taxRate,
  total
}) => (
  <form onSubmit={ (e) => { e.preventDefault(); onSavePendingDocument(); } }>
    <DocumentTypeSelector documentType={ documentType } onChangeDocumentType={ onChangeDocumentType } />
    { renderFormElement("Vendor", "vendor", "text") }
    { renderFormElement("Date", "issued", "date") }
    { renderFormNumberElement("Total", "total", null, null, ".01") }
    { renderFormNumberElement("Tax", "tax", null, null, ".01") }
    { renderFormCalculateTaxElement({ currency, preferredCurrency, total, taxRate, change }) }
    { renderFormElement("Currency", "currency", "select", mapCurrencies(currencies)) }
    { renderPaymentTypeElement(formPaymentType) }
    { renderFormElement("Invoice Number", "invoiceNumber", "text") }
    { renderFormElement("Categories", "categories", "createable", categories, onCreateCategory, accountId) }
    { renderFormElement("Notes", "notes", "notes") }
    <div className={ styles.trash }>
      <Button danger onClick={ () => { onShowTrashDocument(); } }>Trash</Button>
      <span className={ styles.reprocess }>
        <Button onClick={ () => { onReprocessPendingDocument(focusedDocument); } }>Process Automatically</Button>
      </span>
    </div>
    <div className={ styles.save }>
      <FormButton text={ "Save" } />
    </div>
  </form>
);

PendingReceiptForm.propTypes = {
  accountId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType).isRequired,
  change: PropTypes.func.isRequired,
  currencies: PropTypes.arrayOf(currencyType).isRequired,
  currency: currencyType.isRequired,
  documentType: PropTypes.string.isRequired,
  focusedDocument: focusedDocumentType.isRequired,
  formPaymentType: paymentTypeType.isRequired,
  onChangeDocumentType: PropTypes.func.isRequired,
  onCreateCategory: PropTypes.func.isRequired,
  onReprocessPendingDocument: PropTypes.func.isRequired,
  onSavePendingDocument: PropTypes.func.isRequired,
  onShowTrashDocument: PropTypes.func.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  taxRate: PropTypes.number.isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const selector = formValueSelector("pendingReceiptForm");
PendingReceiptForm = connect((state) => {
  const { currency, total, tax, formPaymentType } = selector(state, "currency", "total", "tax", "formPaymentType");
  return { currency, total, tax, formPaymentType };
})(PendingReceiptForm);

export const ReceiptFields = reduxForm({ form: "pendingReceiptForm" })(PendingReceiptForm);

const mapCurrencies = (currencies) => currencies.map(currency => ({ name: currency.code, key: currency.code }));



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/receipt-fields.jsx